// stylelint-disable declaration-no-important
@import '../../style/index';

@include host {
  margin-top: var(--spacings-xl);
  scroll-margin-top: rem-calc(260px);

  .marker {
    display: block;
    width: rem-calc(120px);
    height: rem-calc(4px);
    background: var(--colors-dark-base);
    margin-bottom: var(--spacings-l);
  }

  .reverse {
    flex-direction: row-reverse;
  }

  .headline {
    margin-bottom: var(--spacings-l);
  }

  .text {
    margin: 0;
    color: var(--colors-dark-light);
    font-size: rem-calc(20px);
    line-height: rem-calc(30px);

    @include large-up() {
      font-size: rem-calc(24px);
      line-height: rem-calc(36px);
    }
  }
}
